import { Injectable, inject } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { InMemoryAuthDataService } from './in-memory-auth-data.service';
import { InMemoryStoreDataService } from './in-memory-store-data.service';
import { InMemoryEmployeeDataService } from './in-memory-employee-data.service';
import { InMemoryUsersDataService } from './in-memory-users-data.service';
import { InMemoryUserGroupsDataService } from './in-memory-user-groups-data.service';
import { InMemoryEmailDataService } from './in-memory-email-data.service';
import { InMemoryUserActivityDataService } from './in-memory-user-activity-data.service';
import { InMemoryFootfallPredictionsDataService } from './in-memory-footfall-predictions-data.service';
import { InMemoryEmployeesPredictionsDataService } from './in-memory-employees-predictions-data.service';
import { InMemoryCapabilityDataService } from './in-memory-capability-data.service';
import { InMemoryRotaDataService } from './in-memory-rota-data.service';

/**
 * This factory service produces an implementation of {@link InMemoryHttpClient} interface.
 */
@Injectable({
  providedIn: 'root',
})
export class InMemoryHttpClientFactoryService {
  private inMemoryAuthDataService = inject(InMemoryAuthDataService);
  private inMemoryFootfallPredictionDataService = inject(InMemoryFootfallPredictionsDataService);
  private inMemoryEmployeesPredictionDataService = inject(InMemoryEmployeesPredictionsDataService);
  private inMemoryStoreDataService = inject(InMemoryStoreDataService);
  private inMemoryEmployeeDataService = inject(InMemoryEmployeeDataService);
  private inMemoryCapabilityDataService = inject(InMemoryCapabilityDataService);
  private inMemoryUserDataService = inject(InMemoryUsersDataService);
  private inMemoryUserActivityDataService = inject(InMemoryUserActivityDataService);
  private inMemoryUserGroupsDataService = inject(InMemoryUserGroupsDataService);
  private inMemoryEmailDataService = inject(InMemoryEmailDataService);
  private inMemoryRotaDataService = inject(InMemoryRotaDataService);


  /**
   * Gets an implementation of {@link InMemoryHttpClient} interface by the given {@link collectionName}.
   * @param collectionName a part of the request URL.
   */
  getInMemoryHttpClient(collectionName: string): InMemoryHttpClient {
    switch (collectionName) {
      case 'auth':
        return this.inMemoryAuthDataService;
      case 'footfall-predictions':
        return this.inMemoryFootfallPredictionDataService;
      case 'required-employees-predictions':
        return this.inMemoryEmployeesPredictionDataService;
      case 'stores':
        return this.inMemoryStoreDataService;
      case 'employees':
        return this.inMemoryEmployeeDataService;
      case 'capability':
        return this.inMemoryCapabilityDataService;
      case 'users':
        return this.inMemoryUserDataService;
      case 'user-groups':
        return this.inMemoryUserGroupsDataService;
      case 'user-activity':
        return this.inMemoryUserActivityDataService;
      case 'email':
        return this.inMemoryEmailDataService;
      case 'rotas':
        return this.inMemoryRotaDataService;
      default:
        return undefined;
    }
  }
}
